const PROPERTY_MIN_COST = 3000000;
const PROPERTY_MAX_COST = 50000000;

export const mortgageConfig = {
  propertyCost: {
    min: PROPERTY_MIN_COST,
    max: PROPERTY_MAX_COST,
    step: 50000,
    defaultValue: 7000000,
    rightAdornment: '₽',
  },
  downPayment: {
    min: 0,
    max: PROPERTY_MAX_COST * 0.9,
    step: 5000,
    defaultValue: PROPERTY_MAX_COST * 0.1,
    rightAdornment: '₽',
  },
  creditTerm: {
    min: 1,
    max: 30,
    step: 1,
    defaultValue: 15,
    rightAdornment: 'лет',
  },
  rate: {
    min: 3.1,
    max: 11,
    step: 0.1,
    defaultValue: 5,
    rightAdornment: '%',
  },
};

export const downPaymentOptions = [
  { label: '20%', value: 20 },
  { label: '25%', value: 25 },
  { label: '30%', value: 30 },
];

export const creditTermOptions = [
  { label: '5 лет', value: 5 },
  { label: '10 лет', value: 10 },
  { label: '15 лет', value: 15 },
  { label: '20 лет', value: 20 },
];

export const rateOptions = [
  { label: '4.5%', value: 4.5 },
  { label: '6%', value: 6 },
  { label: '7.5%', value: 7.5 },
  { label: '9.1%', value: 9.1 },
  { label: '10%', value: 10 },
];
